import createReactComponent from '../createReactComponent';
var Heading = createReactComponent('Heading', [['path', {
  d: 'M6 12h12',
  key: '8npq4p'
}], ['path', {
  d: 'M6 20V4',
  key: '1w1bmo'
}], ['path', {
  d: 'M18 20V4',
  key: 'o2hl4u'
}]]);
export default Heading;